import {JackpotBetWinHighlightMRGreenBox} from "./jackpot-bet-win-highlight.mrgreen.box";

export const JackpotBetWinHighlightMRGreenCisBox = JackpotBetWinHighlightMRGreenBox;